import styled from 'styled-components';
const percentageSize = 1.3;

export const CardContainer = styled.div`
  width: 100%;
  min-height: 33px;
  height: fit-content;
  background-color: #333;
  color: white;
  border: 0px solid transparent;
  border-radius: 5px;
  margin-bottom: 5px;
  padding: 2px;
  cursor: pointer;

  :hover {
    /* min-height: 35px; */
    box-shadow: 0 0px 5px #febf00dd;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  @media screen and (max-width: 1023px) {
    line-height: 14px;
  }
`;

export const InfoCard = styled.div`
  display: flex;
  width: 90%;
  flex-direction: row;
  align-items: center;
`;

export const InfoWrapper = styled.div`
  display: flex;
  max-width: 1000px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex-direction: column;

  @media screen and (max-width: 464px) {
    flex-direction: column;
  }
`;

export const TipusIconWrapper = styled.div`
  height: 100%;
  padding: 2px;
  padding-left: 5px;
  margin-right: 10px;
`;

export const NomResultat = styled.span`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
  letter-spacing: 0.7px;

  @media screen and (max-width: 1023px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  }

  @media screen and (max-width: 768px) {
  }

  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
    padding-top: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 250px;
  }
`;

export const InfoAuxiliar = styled.span`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  font-weight: 300;
  color: #ccc;
  display: flex;
  align-items: center;

  @media screen and (max-width: 1023px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  }

  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
    margin: 0;
    padding-top: 5px;
    padding-bottom: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 250px;
  }
`;

export const VisualitzarIconWrapper = styled.div`
  height: 100%;
  padding: 2px;
  padding-right: 5px;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 415px) {
    display: none;
  }
`;

export const InfoCardSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;
